import { Box, Chip, styled } from "@mui/material";

import Select from "../Select";

export const LabelAddAll = styled("span")(() => ({
  display: "flex",
  alignItems: "center",
  color: "#0055A4",
}));

export const LabelRemoveAll = styled("span")(() => ({
  display: "flex",
  alignItems: "center",
  color: "#D92D20",
}));

export const ChipBox = styled(Box)(() => ({
  display: "inline",
  flexWrap: "wrap",
  textOverflow: "ellipsis",
  height: 40,
  alignItems: "center",
}));

export const ChipValue = styled(Chip)(() => ({
  backgroundColor: "#EDF5FB !important",
  color: "#0055A4 !important",
  margin: "2px",
}));

export const ChipCount = styled(Chip)(() => ({
  color: "#fff",
  background: "#0055A4",
  fontWeight: 600,
  marginTop: 5,
}));

export const SelectCustom = styled(Select)(() => ({
  whiteSpace: "nowrap",
  overflow: "hidden",
  "& fieldset": {
    "& legend": {
      fontSize: 0,
      margin: 0,
      "& span": {
        display: "none",
      },
    },
  },
}));
